import { AgendaTaskItemModel } from "./agenda-task-item.model";

export class AgendaTaskModel {
  public constructor(init?: Partial<AgendaTaskModel>) {
    Object.assign(this, init);
  }
  AgendaSettingsId: number;
  Title: string;
  Items: AgendaTaskItemModel[];
}
